"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVersion = void 0;
var _axios = _interopRequireDefault(require("axios"));
const getVersion = () => _axios.default.get('/version.json', {
  params: {
    timestamp: Date.now()
  }
});
exports.getVersion = getVersion;